import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR,
  FETCH_PRODUCT_REVIEWS,
  FETCH_PRODUCT_REVIEWS_SUCCESS,
  FETCH_PRODUCT_REVIEWS_ERROR,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_ERROR,
  CHANGE_PRODUCT_DETAILS,
  FETCH_RELATED_PRODUCTS,
  FETCH_RELATED_PRODUCTS_SUCCESS,
  FETCH_RELATED_PRODUCTS_ERROR,
  UPDATE_RECENTLY_VIEWED,
  UPDATE_RECENTLY_VIEWED_SUCCESS,
  UPDATE_RECENTLY_VIEWED_ERROR,
} from '../actionTypes';

const INIT_STATE = {
  items: [],
  error: '',
  loading: false,
  productDetail: null,
  itemPagination: {
    current: 0,
    pageSize: 12,
    total: 0,
  },
  reviews: [],
  reviewPagination: {
    current: 0,
    pageSize: 12,
    total: 0,
  },
  itemFilters: null,
  relatedProducts: [],
  recentlyViewed: [],
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return { ...state, loading: true, error: '' };
    case FETCH_PRODUCTS_SUCCESS: {
      const { current, pageSize = 12, total = 0 } = action.pageData;
      return {
        ...state,
        loading: false,
        items: action.payload,
        error: '',
        itemPagination: {
          current,
          pageSize,
          total,
        },
      };
    }
    case FETCH_PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_PRODUCT_REVIEWS:
      return { ...state, loading: true, error: '' };
    case FETCH_PRODUCT_REVIEWS_SUCCESS: {
      const { current, pageSize = 4, total = 0 } = action.pageData;
      return {
        ...state,
        loading: false,
        reviews: action.payload,
        error: '',
        reviewPagination: {
          current,
          pageSize,
          total,
        },
      };
    }
    case FETCH_PRODUCT_REVIEWS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_PRODUCT_DETAILS:
      return { ...state, loading: true, error: '', productDetail: null };
    case FETCH_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        productDetail: action.payload,
        error: '',
      };
    case FETCH_PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case CHANGE_PRODUCT_DETAILS:
      return {
        ...state,
        productDetail: { ...state.productDetail, ...action.payload },
      };
    case FETCH_RELATED_PRODUCTS:
      return { ...state, loading: true, error: '' };
    case FETCH_RELATED_PRODUCTS_SUCCESS: {
      return {
        ...state,
        relatedProducts: [...action.payload],
        loading: false,
      };
    }
    case FETCH_RELATED_PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case UPDATE_RECENTLY_VIEWED:
      return { ...state, loading: true, error: '' };
    case UPDATE_RECENTLY_VIEWED_SUCCESS: {
      return {
        ...state,
        recentlyViewed: [...action.payload],
        loading: false,
      };
    }
    case UPDATE_RECENTLY_VIEWED_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default reducer;
